module.exports = __webpack_public_path__ + "media/images/Gestion des déchets-59116a64fb29e4112a3f0408f00ff7f4.svg";